import { action } from '@ember/object';
import Component from '@glimmer/component';

import { BlockFontSize } from 'webapp/enums/enums';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsFontSizeComponent extends Component<Args> {
	options: { value: BlockFontSize; label: string; icon: IconName; iconSize: IconSize }[] = [
		{
			value: BlockFontSize.SMALL,
			label: 'Small',
			icon: 'SmallText',
			iconSize: 'xs' as const,
		},
		{
			value: BlockFontSize.MEDIUM,
			label: 'Normal',
			icon: 'MediumText',
			iconSize: 'sm' as const,
		},
		{
			value: BlockFontSize.LARGE,
			label: 'Large',
			icon: 'LargeText',
			iconSize: 'lg' as const,
		},
	];

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get selected(): BlockFontSize {
		return this.block.fontSize;
	}

	@action
	changeSelected(fontSize: AnySimpleValue): void {
		this.block.fontSize = fontSize as BlockFontSize;
		this.blockSetup.trackBlockPropertySettingsChangeEvent({ font_size: fontSize });
		this.blockSetup.saveBlock();
	}
	<template>
		<div class="row font-size">
			<label>Font size</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="fontSize"
				@selected={{this.selected}}
				@options={{this.options}}
				@onChange={{this.changeSelected}}
				@theme="dark-blue"
			/>
		</div>
	</template>
}
